var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"icon-link"},[_c('a',{attrs:{"href":_vm.link,"target":_vm.newTab ? '_blank' : '',"rel":"noopener noreferrer"}},[_c('v-icon',{class:{
				'link-icon-small' : _vm.isSmall,
				'link-icon-big' : !_vm.isSmall
			},attrs:{"name":"external-link"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }